export default function single_comment() {
  $('#link-comments').click(function(e){
    e.preventDefault();

    $('#comments-container').slideToggle();
  });
}